export const isMainEditorContent = (target: EventTarget | null): boolean => {
	if (!(target instanceof HTMLElement)) return false;
	if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return false;
	if (target.closest('[data-testid="ak-editor-plugin-ai-modal"]')) return false;
	if (target.closest('[data-testid^="ak-editor-ai"]')) return false;
	if (target.closest('[data-testid="rovo-prompt-session-screen"]')) return false;
	if (target.closest('[data-testid="chromeless-editor"]')) return false;
	return target.closest('.ProseMirror') !== null;
};
